// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface LocationGpsIconSignature {
  Element: SVGSVGElement;
}

export const LocationGpsIcon: TOC<LocationGpsIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M22 11H19.931C19.477 7.388 16.612 4.523 13 4.069V2H11V4.069C7.389 4.523 4.523 7.388 4.069 11H2V13H4.069C4.523 16.612 7.388 19.478 11 19.931V22H13V19.931C16.612 19.477 19.477 16.612 19.931 13H22V11ZM12 18C8.691 18 6 15.308 6 12C6 8.692 8.691 6 12 6C15.309 6 18 8.692 18 12C18 15.308 15.309 18 12 18ZM9.87866 14.1213C11.0502 15.2929 12.9497 15.2929 14.1213 14.1213C15.2929 12.9497 15.2929 11.0503 14.1213 9.87868C12.9497 8.70711 11.0502 8.70711 9.87866 9.87868C8.70709 11.0503 8.70709 12.9497 9.87866 14.1213Z"/>
</svg>
</template>;